<template>
  <div class="sample-type-dropdown">
    <div class="dropdown-container" ref="dropdownContainer">
      <label for="custom-dropdown" class="dropdown-label"> {{$tI_G('Filter by sample dropdown title')}}  </label>
      <div class="select-custom-dropdown">
        <div class="dropdown-select" @click="toggleDropdown">{{ $tI(selectedSampleTypeName) || 'Global' }}</div>
        <div class="custom-dropdown-menu cs-scroll-style" v-if="isDropdownOpen">
          <div 
            v-for="(item, index) in sampleTypeList" 
            :key="index" 
            class="custom-dropdown-item" 
            @click="selectSampleType(item)"
            v-click-track="'Iframe.ancientDnaSampleDatabaseFilteredBySampleType'"
          >
            {{ $tI(item.title) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    modalObject: {
      type: Object,
    },
    callback: {
      type: Function,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      selectedSampleType: 'ANCIENT',

      sampleTypeList: [
        {
          id: 'ANCIENT',
          title: 'Ancient population filter',
        },
        {
          id: 'MODERN',
          title: 'Modern populations filter',
        },
        {
          id: 'ANCIENT-INDIVIDUAL',
          title: 'Ancient samples filter',
        },
      ],
    }
  },
  methods: {
    applySelectedSampleType() {
      this.$store.state.sampleDatabase.selectedSampleType = this.selectedSampleType;
      this.$store.state.sampleDatabase.filterQuery.location = '';
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectSampleType(item) {
      this.selectedSampleType = item.id;
      this.isDropdownOpen = false;
      this.applySelectedSampleType();
    },

    closeDropdown(event) {
      if (!this.$refs.dropdownContainer.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
  },
  computed: {
    selectedSampleTypeName() {
      return this.sampleTypeList.find(x => x.id === this.selectedSampleType).title;
    },
  },
  mounted() {
    this.selectedSampleType = this.$store.state.sampleDatabase.selectedSampleType;
    document.addEventListener('click', this.closeDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown);
  },
};
</script>

<style lang="scss" scoped>
.sample-type-dropdown {
  .dropdown-container {
    padding: 0;
    width: 100%;

    .select-custom-dropdown {
      width: 100%;
    }
  }
}

</style>
